const actualBtn = document.querySelectorAll('.file-upload')
const fileChosen = document.querySelectorAll('.file-chosen')
const resetBtn = document.querySelectorAll('.reset-upload')

if (typeof (actualBtn) !== 'undefined' && actualBtn !== null) {
  actualBtn.forEach((element, i) => {
    element.setAttribute('hidden', 'hidden')
    element.addEventListener('change', () => {
      fileChosen[i].textContent = element.files[0].name
      resetBtn[i].classList.add('show')
    })
    resetBtn[i].addEventListener('click', () => {
      resetBtn[i].classList.remove('show')
      element.value = ''
      fileChosen[i].textContent = ''
    })
  })
}

document.addEventListener('DOMContentLoaded', function () {
  // Das <select> Element anhand seiner ID finden
  const selectElement = document.getElementById('selectoptions')

  if (selectElement) {
    selectElement.addEventListener('change', function () {
      const url = this.value
      if (url) {
        window.location = url
      }
    })
  }
})
